export default __webpack_public_path__ + "static/media/ArialBlack.bcbbcd9b.ttf";